const SURFLY_IFRAME_ID = 'surfly-iframe'
const SURFLY_INVISIBLE_CLASS = 'surfly-invisible'
const ONETRUST_SDK_ID = 'onetrust-consent-sdk'

/*
 * Surfly keeps its iframe mounted for the whole page lifetime and only swaps the
 * class (surfly-invisible -> surfly-popup / surfly-ignore) once the session is on screen.
 */
const isSurflySessionVisible = (): boolean => {
  const surflyIframe = document.getElementById(SURFLY_IFRAME_ID)

  return (
    !!surflyIframe && !surflyIframe.classList.contains(SURFLY_INVISIBLE_CLASS)
  )
}

const applyOneTrustVisibility = (): void => {
  const oneTrustSdk = document.getElementById(ONETRUST_SDK_ID)

  if (!oneTrustSdk) return

  oneTrustSdk.style.display = isSurflySessionVisible() ? 'none' : ''
}

/**
 * Hides the OneTrust consent SDK while a Surfly session is visible so it cannot overlap
 * the Surfly PIN modal, and restores it once the session goes back to invisible.
 *
 * @returns cleanup that disconnects the observers
 */
const syncOneTrustWithSurfly = (): (() => void) => {
  let iframeObserver: MutationObserver | null = null
  let observedIframe: HTMLElement | null = null

  const watchIframeClass = (): void => {
    const surflyIframe = document.getElementById(SURFLY_IFRAME_ID)

    if (surflyIframe === observedIframe) return

    if (iframeObserver) {
      iframeObserver.disconnect()
      iframeObserver = null
    }

    observedIframe = surflyIframe

    if (!surflyIframe) return

    iframeObserver = new MutationObserver(applyOneTrustVisibility)
    iframeObserver.observe(surflyIframe, { attributeFilter: ['class'] })
  }

  const syncVisibility = (): void => {
    watchIframeClass()
    applyOneTrustVisibility()
  }

  syncVisibility()

  /*
   * Surfly appends #surfly-iframe as a fixed-position overlay, sometimes as a sibling
   * of <body> rather than inside it, so <html> is observed instead of just <body>.
   */
  const documentObserver = new MutationObserver(syncVisibility)
  documentObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  })

  return () => {
    documentObserver.disconnect()

    if (iframeObserver) {
      iframeObserver.disconnect()
      iframeObserver = null
    }
  }
}

export default syncOneTrustWithSurfly
